// @flow
import React, { createContext } from 'react';
import { Grid } from 'semantic-ui-react';
import { getIn, useFormikContext } from 'formik';
import { TinyHeaderSpan } from '@presentational/headings/TinyHeaderSpan';
import { Tooltip } from '@presentational/Tooltip';

export const FixedRowsGridRowContext = createContext({});

// A grid with a fixed (non-dynamic) set of rows, driven by a columns configuration — unlike
// FieldArrayGrid, whose rows are added/removed dynamically.
// The rows come from the form values at pathToFollowInValues; each column renders its CellComponent,
// which reads its per-row data from FixedRowsGridRowContext.
export const FixedRowsGrid = ({ columnsConfiguration, pathToFollowInValues, readOnly }) => {
  const { values } = useFormikContext();
  const rows = getIn(values, pathToFollowInValues) ?? [];

  return (
    <Grid>
      <Grid.Row columns={columnsConfiguration.length}>
        {columnsConfiguration.map((column) => {
          const { key, width, headerText, headerTooltip } = column;

          return (
            <Grid.Column key={key} width={width}>
              {headerText ? <TinyHeaderSpan headerText={headerText} /> : null}
              {headerTooltip ? <Tooltip content={headerTooltip} /> : null}
            </Grid.Column>
          );
        })}
      </Grid.Row>

      {rows.map((_, rowIndex) => (
        <FixedRowsGridRowContext.Provider
          key={`fixed-rows-grid-row-${rowIndex}`}
          value={{ readOnly, rowIndex, rows }}
        >
          <Grid.Row columns={columnsConfiguration.length} verticalAlign="middle">
            {columnsConfiguration.map((column) => {
              const { key, width, CellComponent } = column;

              return (
                <Grid.Column key={key} width={width}>
                  <CellComponent />
                </Grid.Column>
              );
            })}
          </Grid.Row>
        </FixedRowsGridRowContext.Provider>
      ))}
    </Grid>
  );
};
